import type { Position } from "@/types/workflowDefinition";

// Spacing between nodes (should match layoutEngine flowSpacing - DEFAULT_NODE_WIDTH/HEIGHT gap)
export const NODE_SPACING = 40;

// Default position for first trigger (x offset accounts for left panel rail)
export const DEFAULT_TRIGGER_POSITION: Position = { x: 250, y: 100 };

// Snap grid interval (10 pixels - noticeable but precise)
export const SNAP_GRID: [number, number] = [10, 10];

// Default node dimensions (used as fallback before measurement)
export const DEFAULT_NODE_WIDTH = 200;
export const DEFAULT_NODE_HEIGHT = 120;

// Floating node icon box size
export const FLOATING_ICON_BOX_SIZE = 56;
